import React, { useState } from "react";
import { Typography, Grid, Box, Card, TextField, InputAdornment, CardContent } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import moment from "moment";

export default function FormActualizar(props) {
    const { datosExisten, datoslista, style, setDatoslista } = props;
    const [aumento, setAumento] = useState("");
    const [porcentaje, setPorcentaje] = useState("");

    const almacenar = (e) => {
        setDatoslista({
            ...datoslista,
            [e.target.name]: e.target.value,
        });
    };

    const handleActualizarPesos = (e) => {
        const nuevoAumento = e.target.value;
        setAumento(nuevoAumento);
        if (!isNaN(nuevoAumento) && nuevoAumento !== "") {
            setDatoslista({
                ...datoslista,
                precio_sin_iva: datosExisten[0].precio_sin_iva + parseFloat(nuevoAumento),
                precio_iva: datosExisten[0].precio_iva + parseFloat(nuevoAumento)
            })
        } else {
            setDatoslista({
                ...datoslista,
                precio_sin_iva: (datosExisten[0].precio_sin_iva).toFixed(4),
                precio_iva: (datosExisten[0].precio_iva).toFixed(4),
            });
        }
    };

    const handleActualizarPorcentaje = (e) => {
        const nuevoPorcentaje = e.target.value;
        setPorcentaje(nuevoPorcentaje);
        if (!isNaN(nuevoPorcentaje) && nuevoPorcentaje !== "") {
            const porcentajeNumerico = parseFloat(nuevoPorcentaje) / 100;

            setDatoslista({
                ...datoslista,
                precio_sin_iva: datosExisten[0].precio_sin_iva * (1 + porcentajeNumerico),
                precio_iva: datosExisten[0].precio_iva * (1 + porcentajeNumerico)
            })
        }
        setDatoslista({
            ...datoslista,
            precio_sin_iva: (datosExisten[0].precio_sin_iva).toFixed(4),
            precio_iva: (datosExisten[0].precio_iva).toFixed(4),
        });
    };

    return (
        <>
            {datosExisten &&
                <Box sx={{ padding: 2 }}>
                    {/* Card para Precio Vigente */}
                    <Card variant="outlined" sx={{ mb: 1, backgroundColor: "#F4F6F6" }}>
                        <CardContent>
                            <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                                Precio Vigente
                            </Typography>
                            {/* Precios en un solo renglón */}
                            <Grid container spacing={1} alignItems="center" justifyContent="center">
                                {[
                                    { label: "Precio sin IVA", value: datosExisten[0].precio_sin_iva || 0 },
                                    { label: "Precio con IVA", value: datosExisten[0].precio_iva || 0 },
                                ].map((item, index) => (
                                    <Grid item xs={12} sm={6} md={4} key={index}>
                                        <TextField
                                            fullWidth
                                            style={style}
                                            focused
                                            size="small"
                                            variant="outlined"
                                            label={item.label}
                                            value={(item.value).toFixed(4)}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start"><AttachMoneyIcon /></InputAdornment>,
                                                readOnly:true
                                            }}
                                        />
                                    </Grid>
                                ))}
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                        fullWidth
                                        style={style}
                                        focused
                                        size="small"
                                        variant="outlined"
                                        label="Entrada en Vigencia"
                                        value={moment(datosExisten[0].vigencia).format("DD-MM-YYYY") || ""}
                                        InputProps={{ readOnly: true }}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>

                        <CardContent>
                            <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                                Aumento
                            </Typography>
                            <Grid container spacing={1} alignItems="center" justifyContent="center">
                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        fullWidth
                                        style={style}
                                        focused
                                        size="small"
                                        color="secondary"
                                        label="Aumento en pesos"
                                        variant="outlined"
                                        value={aumento}
                                        onChange={handleActualizarPesos}
                                        disabled={porcentaje !== ""}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start"><AttachMoneyIcon /></InputAdornment>,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        style={style}
                                        focused
                                        color="secondary"
                                        label="Aumento en porcentaje"
                                        variant="outlined"
                                        value={porcentaje}
                                        onChange={handleActualizarPorcentaje}
                                        disabled={aumento !== ""}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start"><PercentIcon /></InputAdornment>,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>

                        <CardContent>
                            <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                                Precio Con Aumento
                            </Typography>
                            {/* Precios con aumento en un solo renglón */}
                            <Grid container spacing={1} alignItems="center" justifyContent="center">
                                {[
                                    { label: "Precio sin IVA", name: "precio_sin_iva", value: datoslista.precio_sin_iva || 0 },
                                    { label: "Precio con IVA", name: "precio_iva", value: datoslista.precio_iva || 0 },

                                ].map((item, index) => (
                                    <Grid item xs={12} sm={6} md={4} key={index}>
                                        <TextField
                                            fullWidth
                                            style={style}
                                            focused
                                            size="small"
                                            variant="outlined"
                                            label={item.label}
                                            name={item.name}
                                            value={item.value}
                                            onChange={almacenar}
                                            InputProps={{ startAdornment: <InputAdornment position="start"><AttachMoneyIcon /></InputAdornment> }}
                                        />
                                    </Grid>
                                ))}
                                {/* Fecha Minima */}
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                        fullWidth
                                        style={style}
                                        focused
                                        size="small"
                                        variant="outlined"
                                        label="Fecha de entrada en vigencia"
                                        type="date"
                                        inputProps={{ min: moment(datosExisten[0].vigencia).format("YYYY-MM-DD") }}
                                        name="vigencia"
                                        value={datoslista.vigencia || ""}
                                        onChange={almacenar}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>

                    </Card>
                </Box>
            }
        </>
    )


}